import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Cyprus',
        link: '/banking-license-cyprus',
    },
]

function BankingLicenseCyprus () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Cyprus
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish a Credit Institution with EU Passporting Rights
                            </h3>
                            <p className='page-paragraph'>
                                <b>Mwali (Mohéli)</b>, part of the <b>Union of Comoros</b>, offers <b>internationally recognized offshore banking licenses</b> under the <b>Mwali International Services Authority (MISA)</b>. Known for <b>credibility</b> and <b>flexibility</b>, <b>Mwali</b> is a preferred choice for <b>investors seeking to establish international, private, or digital banks</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Retail Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Private Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Corporate & Investment Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Digital/Neo Banking",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Cyprus Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Cyprus for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "EU & Global Recognition",
                                    paragraph: "Tier-1 regulator with ECB oversight",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Full Credit Institution License",
                                    paragraph: "Full range of banking services allowed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU Passporting Rights",
                                    paragraph: "Serve clients across all EEA countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & Payment Networks",
                                    paragraph: "SEPA, SWIFT, Visa, Mastercard integration",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Cost Advantage",
                                    paragraph: "Lower operating costs vs Luxembourg or Ireland",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "FinTech Banking",
                                    paragraph: "Cyprus is emerging as a base for digital/neo banks",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Services Covered by a Cyprus Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Accepting Deposits from the Public",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Issuing Loans and Credit Facilities",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Providing Debit/Credit Card Programs",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Multi-Currency Accounts & IBAN Issuing",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Custody & Investment Banking Services",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Cross-Border Payment Services",
                                    paragraph: "SEPA/SWIFT",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "FinTech/Digital Banking Solutions",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Capital & Compliance Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Minimum Capital",
                                    paragraph: "€5,000,000 fully paid-up",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fit & Proper Test",
                                    paragraph: "Applied to all shareholders, directors, and executives",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local Presence",
                                    paragraph: "Physical office and at least 2 Cyprus-resident directors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Compliance Systems",
                                    paragraph: "AML/KYC, risk management, governance, annual audits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "ECB Oversight",
                                    paragraph: "Joint supervision under the EU Banking Union",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Cyprus Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Top-Tier Global Recognition",
                                    paragraph: "Supervised by ECB & Central Bank of Cyprus",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU Passporting",
                                    paragraph: "Operate seamlessly across 30+ EEA markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "SEPA & SWIFT Access",
                                    paragraph: "Full banking network connectivity",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Strong institutional reputation",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Location",
                                    paragraph: "Gateway between EU, Middle East, and Asia",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define banking model (retail, private, digital)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Incorporation",
                                    paragraph: "Register a Cyprus banking entity",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Submission",
                                    paragraph: "Governance, business plan, capital proof, AML policies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Central Bank & ECB Review",
                                    paragraph: "Due diligence & fit & proper assessment",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Usually 12–18 months",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Operational Setup",
                                    paragraph: "Banking software, compliance systems, card scheme integrations",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "12–18 months",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From €200,000+ (legal, compliance, advisory)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "€5,000,000 minimum",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Supervision, audits, ECB reporting",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in EU Banking License Applications",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Incorporation, license filing, compliance, audits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Introductions to Core Banking Software Providers, Card Issuers, and PSPs",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparison Advice",
                                    paragraph: "Cyprus vs Malta vs Offshore banking jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing Compliance & Audit Support Post-Licensing",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking for Tier-1 EU banking credibility?"
                        description=
                            "A <b>Cyprus Banking License</b> offers <b>global trust</b>, <b>EU passporting</b>, and <b>ECB oversight</b> — making it the <b>gold standard for retail, private, and fintech banks</b>."
                        buttonText="Book a Cyprus Banking License Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicenseCyprus;

const faqData = [
    {
        question: "How recognized is a Cyprus banking license?",
        content: [
            { type: "answer", text: "It is fully EU-recognized, supervised by the ECB, and carries Tier-1 credibility." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "Minimum €5 million fully paid-up capital." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "12–18 months, depending on the business model." },
        ],
    },
    {
        question: "Can I launch a digital/neo bank in Cyprus?",
        content: [
            { type: "answer", text: "Yes — Cyprus is increasingly used as a base for digital banks." },
        ],
    },
    {
        question: "Do I need local directors?",
        content: [
            { type: "answer", text: "Yes — at least two Cyprus-resident directors with banking/finance expertise." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We launched a private bank in Cyprus with Offshore Advisory. The ECB approval process was demanding, but the credibility is unmatched.",
        author: "Michael T.",
        role: "Banking Investor",
    },
    {
        quote:
            "Our digital bank was licensed in Cyprus. Offshore Advisory managed compliance, Central Bank filings, and card integrations.",
        author: "Anna S.",
        role: "FinTech Bank Founder",
    },
];